'use strict';

const searchForm = {
	el : $('.js-search-form'),
	body : $('body'),
	toggleShow () {
		if (!this.el.hasClass('current')) {
			this.el.toggleClass('current');
			this.el.after($(`<div class="formOveflow">`));

		} else{
			this.el.toggleClass('current');
			setTimeout(() => {
				$('.formOveflow').remove();
			}, 300)
		}
	}
}
$(document).on('click', '.js-search-toggle, .js-search-close', function() {
	searchForm.toggleShow();
});
$(document).on('touchstart', '.formOveflow', function() {
	searchForm.toggleShow();
})